var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"min-h-screen-dynamic bg-ink-400 print:bg-transparent"},[_c('Nuxt'),_vm._v(" "),_c('portal-target',{staticClass:"z-1000",attrs:{"name":"modal"},on:{"change":_vm.modalToggled}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }